import { APP } from '../../commons/reducer';
import { createAction, createReducer } from '../../utils/reducer';
const PATH = 'trackingNumber/';
const CONTROLS_CHANGED = `${PATH}CONTROLS_CHANGED`;

export const TRACKING_NUMBER = {
  GET_TRACKING_NUMBER_STATUS: `${PATH}PICKUP_LIST`,
  GET_TRACKING_NUMBER_STATUS_SUCCESS: `${PATH}PICKUP_LIST_SUCCESS`,
  GET_TRACKING_NUMBER_STATUS_FAILED: `${PATH}PICKUP_LIST_FAILED`,
};

export const trackingActions = {
  trackingStatusChanged: createAction(CONTROLS_CHANGED, 'controls'),
  getTrackingNumber: createAction(
    TRACKING_NUMBER.GET_TRACKING_NUMBER_STATUS,
    'trackingNumber',
  ),
  getTrackingNumberSuccess: createAction(
    TRACKING_NUMBER.GET_TRACKING_NUMBER_STATUS_SUCCESS,
    'trackingStatus',
  ),
  getTrackingNumberFailed: createAction(
    TRACKING_NUMBER.GET_TRACKING_NUMBER_STATUS_FAILED,
    'trackingStatus',
  ),
};

const initialState = {
  trackingStatus: {
    trackingNumber: '',
    errorMessage: '',
    error: false,
    loading: false,
    success: null,
  },
  status: null,
};

const trackingNumber = createReducer(initialState, {
  [CONTROLS_CHANGED](state: any, action: any) {
    state.trackingStatus = {
      ...state.trackingStatus,
      ...action.trackingStatus,
    };
    state.status = null;
  },
  [TRACKING_NUMBER.GET_TRACKING_NUMBER_STATUS](state: any) {
    state.trackingStatus.loading = true;
    state.status = null;
  },
  [TRACKING_NUMBER.GET_TRACKING_NUMBER_STATUS_SUCCESS](
    state: any,
    action: any,
  ) {
    state.status = action.trackingStatus;
    state.trackingStatus.loading = false;
  },
  [TRACKING_NUMBER.GET_TRACKING_NUMBER_STATUS_FAILED](state: any, action: any) {
    state.trackingStatus.error = true;
    state.trackingStatus.loading = false;
    state.status = action.trackingStatus;
    state.trackingStatus.errorMessage = 'Oops, wrong credentials.';
  },
  [APP.SERVER_FAILED](state: any) {
    state.trackingStatus.loading = false;
  },
});

export default trackingNumber;
